import React from 'react';
import { Tooltip } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';
import { PackageDtoModelType, ScannedPackageDtoModelType } from '../../../../../store/mst/models';
import {
  PackagesContainer,
  PackageRow,
  PackageBarcode,
  ScannedPackageCheckbox,
  CheckboxColumn,
} from './atoms';

interface Props {
  packages: PackageDtoModelType[];
  scannedPackages?: ScannedPackageDtoModelType[] | null;
}

const PackagesSection: React.FC<Props> = ({ packages, scannedPackages }) => {
  const { t } = useTranslation('common');

  if (!packages || packages.length === 0) {
    return null;
  }

  const getScannedPackage = (packageUuid: string) => {
    return scannedPackages?.find(scannedPkg => scannedPkg.uuid === packageUuid);
  };

  const getTooltipTitle = (scanLog?: ScannedPackageDtoModelType) => {
    if (scanLog && scanLog.scannedTime) {
      return (
        t('visitFields.packageTooltip.scanned', {
          date: scanLog?.scannedDateString,
          time: scanLog?.scannedTimeString,
        })
      );
    }
    return t('visitFields.packageTooltip.notScanned');
  };

  return (
    <PackagesContainer data-testid="packages-section">
      {packages.map((pkg, index) => {
        const scannedPackage = getScannedPackage(pkg.uuid);

        return (
          <PackageRow
            key={pkg.uuid}
            data-testid={`package-row-${index}`}
          >
            <Tooltip title={getTooltipTitle(scannedPackage)}>
              <PackageBarcode data-testid={`package-barcode-${index}`}>
                {pkg.barcode}
              </PackageBarcode>
            </Tooltip>
            <CheckboxColumn>
              {scannedPackage && (
                <Tooltip title={getTooltipTitle(scannedPackage)}>
                  <ScannedPackageCheckbox uuid={pkg.uuid} />
                </Tooltip>
              )}
            </CheckboxColumn>
          </PackageRow>
        );
      })}
    </PackagesContainer>
  );
};

export default PackagesSection;
